export const isUndefinedOrNull = <T>(value: T | null | undefined): value is null | undefined => value == null

/**
 * Verifica se um valor é estritamente `null`, substituindo o `isNull` do lodash.
 *
 * Diferente de {@link isUndefinedOrNull} (que também considera `undefined`), aqui apenas `null`
 * retorna `true` — equivalente a `value === null`.
 */
export const isNull = <T>(value: T | null): value is null => value === null

/**
 * Verifica se um valor está "vazio", substituindo o `isEmpty` do lodash por implementação nativa.
 *
 * Considera vazio: `null`, `undefined`, string ou array sem elementos, objeto sem chaves próprias e
 * `Map`/`Set` sem entradas. Assim como no lodash, números e booleanos são sempre considerados vazios,
 * pois não possuem propriedades enumeráveis.
 */
export function isEmpty(value: unknown): boolean {
  if (value == null) return true
  if (typeof value === 'string' || Array.isArray(value)) return value.length === 0
  if (value instanceof Map || value instanceof Set) return value.size === 0
  if (typeof value === 'object') return Object.keys(value).length === 0
  return true
}

/**
 * Verifica se um valor é um objeto ou uma função, substituindo o `isObject` do lodash.
 *
 * Assim como no lodash, arrays, `Map`/`Set` e funções também são considerados objetos;
 * apenas `null` e os demais primitivos retornam `false`.
 */
export function isObject(value: unknown): value is object {
  const type = typeof value
  return value != null && (type === 'object' || type === 'function')
}
